import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as SearchIcon } from 'assets/search-icon.svg';
import i18nContext from 'components/i18n-context';
import Input from 'uikit/Input/Input';
import { InputDropDown } from 'uikit/InputDropDown/InputDropDown';
import './TemplatesTableFilters.scss';

const TemplatesTableFilters = ({ filters, userAccounts, onFilterChange, handleSearchText }) => {
  const i18n = useContext(i18nContext);

  const currencyOptions = [...new Set(userAccounts?.map(({ currency }) => currency))].map((currency) => {
    return {
      key: currency,
      value: currency
    };
  });

  return (
    <div className={'templates-filters'}>
      <div className={'filter-group'}>
        <InputDropDown
          className={'templates-filter-input currency'}
          name={'currency'}
          value={filters.currency}
          options={currencyOptions}
          onChange={onFilterChange}
          placeholder={i18n.getMessage('unapprovedPayments.filters.currency.placeholder')}
          isMulti
        />
        <Input
          className={'templates-filter-input search-text-input'}
          name={'search_text'}
          value={filters.search_text}
          onChange={handleSearchText}
          placeholder={i18n.getMessage('unapprovedPayments.filters.search.placeholder')}
          Icon={SearchIcon}
        />
      </div>
    </div>
  );
};

TemplatesTableFilters.propTypes = {
  filters: PropTypes.object,
  userAccounts: PropTypes.array,
  onFilterChange: PropTypes.func,
  handleSearchText: PropTypes.func
};

export default TemplatesTableFilters;
